import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkGetArchivedPlanRecord } from '../types';

const onGetArchivedPlanRecord: IThunkGetArchivedPlanRecord = thunk(
  async (_, { signal, ...request }) =>
    api.communityEngagement
      .getHistoryMonthlyRecord(request, signal)
      .then(response => response.data),
);

export default onGetArchivedPlanRecord;
